import { useQuery } from "@tanstack/react-query";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

export const useProfileImageUrl = (clinicianId, isClinician) => {
    return useQuery({
        queryKey: ["profileImage", clinicianId],
        queryFn: async () => {
            const storage = getStorage();
            const imageRef = ref(
                storage,
                `ClinicianProfileImages/${clinicianId}.webp`,
            );
            return getDownloadURL(imageRef);
        },
        enabled: !!clinicianId && !!isClinician,
        staleTime: Infinity,
    });
};
